export default "__VITE_ASSET__7Lj9vK5I__"